// frontend/src/core/api/auth.js

// Universal auth endpoints. Region-agnostic.
import { apiFetch } from './client';

export const authenticate = (email, password, rememberMe = false) =>
  apiFetch('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password, rememberMe }),
  });

export const register = (email, password) =>
  apiFetch('/api/auth/register', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });

export const requestPasswordReset = (email) =>
  apiFetch('/api/auth/request-password-reset', {
    method: 'POST',
    body: JSON.stringify({ email }),
  });

export const resetPassword = (token, password) =>
  apiFetch('/api/auth/reset-password', {
    method: 'POST',
    body: JSON.stringify({ token, password }),
  });

export const refreshSession = () =>
  apiFetch('/api/auth/refresh', { method: 'POST' });

export const fetchCurrentUser = (token) =>
  apiFetch('/api/auth/me', { token });

export const logout = () =>
  apiFetch('/api/auth/logout', { method: 'POST' });